import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import {
  createContract,
  deleteContract,
  generateContract,
  getContract,
  getContracts,
  updateContract,
} from '../services/api.js'

const LIST_KEY = ['contracts']
const contractKey = (id) => ['contract', Number(id)]

/** Liste des contrats (menu Contrats > Contrats) ; hasCompany = une société « Entreprises » existe. */
export function useContracts() {
  return useQuery({ queryKey: LIST_KEY, queryFn: getContracts })
}

/** Un contrat et ses actions. Relu toutes les 3 s pendant la génération (worker). */
export function useContract(id) {
  const queryClient = useQueryClient()
  const query = useQuery({
    queryKey: contractKey(id),
    queryFn: () => getContract(id),
    enabled: Boolean(id),
    refetchInterval: (q) => (['queued', 'running'].includes(q.state.data?.generation?.status) ? 3000 : false),
  })

  const onSuccess = (contract) => {
    if (contract?.id) queryClient.setQueryData(contractKey(contract.id), contract)
    queryClient.invalidateQueries({ queryKey: LIST_KEY })
  }

  return {
    ...query,
    contract: query.data ?? null,
    update: useMutation({ mutationFn: updateContract, onSuccess }),
    generate: useMutation({ mutationFn: generateContract, onSuccess }),
  }
}

export function useCreateContract() {
  const queryClient = useQueryClient()
  return useMutation({ mutationFn: createContract, onSuccess: () => queryClient.invalidateQueries({ queryKey: LIST_KEY }) })
}

export function useDeleteContract() {
  const queryClient = useQueryClient()
  return useMutation({ mutationFn: deleteContract, onSuccess: () => queryClient.invalidateQueries({ queryKey: LIST_KEY }) })
}
